import { AllowancesCard } from "./_components/allowances-card";
import { EmployeesCard } from "./_components/employees-card";
import { LeaveApplicationsCard } from "./_components/leave-applications-card";
import { LoansCard } from "./_components/loans-card";
import { HomeMonthlyReportCard } from "./_components/montly-report-card";

const AdminHomePage = () => {
  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex flex-wrap gap-8">
        <EmployeesCard />

        <LeaveApplicationsCard />

        <AllowancesCard />

        <LoansCard />

        <HomeMonthlyReportCard />
      </div>
    </div>
  );
};

export default AdminHomePage;
